<template>
<div>
    <!-- 待确认 -->
    <el-select v-model="roundNo" placeholder="请选择" v-if="basicFormData.times > 1" size="mini" style="right: 8px;z-index: 1;width: 80px;position: absolute;" @change="changeRoundNo">
        <el-option v-for="index of basicFormData.times" :key="index" :label="index" :value="index"></el-option>
    </el-select>
    <el-tabs @tab-click="handleCheckTabClick" v-model="currTab" v-if="partList.length">
        <el-tab-pane :key="1" label="汇总表" name="summary">
            <div>
                <!-- 比价表 -->
                <!-- 需要零件和供应商的关系 -->
                <!-- 按供应商ID求和 -->
                <!-- checkbox加上去 -->
                <!-- 最低价格涂绿色：到底哪一项最低 -->
                <el-table :data="summaryList" :header-cell-style="{background:'#f5f5f5'}" size="mini" highlight-current-row border stripe max-height="380px" @selection-change="selectionSummaryChange">
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column type="index" width="50" label="序号">
                    </el-table-column>
                    <el-table-column prop="rfqSupplierCode" header-align="center" align="left" label="供应商编号" width="150">
                    </el-table-column>
                    <el-table-column prop="rfqSupplierName" header-align="center" align="left" label="供应商名称" width="150">
                    </el-table-column>
                    <el-table-column prop="sumTargetPrice" header-align="center" align="left" label="目标价格" width="120">
                    </el-table-column>
                    <el-table-column prop="sumOneCarCount" header-align="center" align="left" label="单车用量" width="120">
                    </el-table-column>
                    <el-table-column prop="sumWorkingEquipmentMoney" header-align="center" align="left" label="工装投入" width="120">
                    </el-table-column>
                    <el-table-column prop="sumAmortizationMoney" header-align="center" align="left" label="摊销金额" width="120">
                    </el-table-column>
                    <el-table-column prop="sumOneCarCost" header-align="center" align="left" label="单车成本" width="120">
                    </el-table-column>
                    <el-table-column prop="sumTotalCost" header-align="center" align="left" label="全部成本" width="120">
                    </el-table-column>
                    <el-table-column prop="chooseFlag" header-align="center" align="left" label="定厂" width="120">
                    </el-table-column>
                </el-table>
            </div>
        </el-tab-pane>
        <el-tab-pane :key="2" label="对比表" name="comparison">
            <!-- 零件与供应商 -->
            <!-- 零件编码: {{currentPartCode}} 零件名称: {{currentPartName}} 进度: {{currentPartIndex}}/{{currentPartCount}}
            <div style="float:right">

                <el-button size="mini" :disabled="currentPartIndex === 1" @click="prious">上一个</el-button>
                <el-button size="mini">选择</el-button>
                <el-button size="mini" :disabled="currentPartIndex === currentPartCount" @click="next">下一个</el-button>
            </div> -->
            <!-- 供应商和零件关联报价 -->
            <!-- 按零件求和 -->
            <!-- checkbox加上去 -->
            <el-table :data="priceList" :header-cell-style="{background:'#f5f5f5'}" size="mini" highlight-current-row border stripe max-height="380px" @selection-change="selectionPartChange">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column type="index" width="50" label="序号">
                </el-table-column>
                <el-table-column prop="partCode" header-align="center" align="left" label="零件编码" width="150">
                </el-table-column>
                <el-table-column prop="partName" header-align="center" align="left" label="零件名称" width="150">
                </el-table-column>
                <el-table-column prop="rfqSupplierCode" header-align="center" align="left" label="供应商编号" width="150">
                </el-table-column>
                <el-table-column prop="rfqSupplierName" header-align="center" align="left" label="供应商名称" width="150">
                </el-table-column>
                <el-table-column prop="targetPrice" header-align="center" align="right" label="目标价格" width="120">
                </el-table-column>
                <el-table-column prop="targetPrice" header-align="center" align="left" label="目标价格" width="120">
                </el-table-column>
                <el-table-column prop="oneCarCount" header-align="center" align="left" label="单车用量" width="120">
                </el-table-column>
                <el-table-column prop="workingEquipmentMoney" header-align="center" align="left" label="工装投入" width="120">
                </el-table-column>
                <el-table-column prop="amortizationMoney" header-align="center" align="left" label="摊销金额" width="120">
                </el-table-column>
                <el-table-column prop="oneCarCost" header-align="center" align="left" label="单车成本" width="120">
                </el-table-column>
                <el-table-column prop="totalCost" header-align="center" align="left" label="全部成本" width="120">
                </el-table-column>
                <el-table-column prop="supplyRadio" header-align="center" align="left" label="供货比例" width="120">
                </el-table-column>
                <el-table-column prop="chooseFlag" header-align="center" align="left" label="定厂" width="120">
                </el-table-column>
            </el-table>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import {
    getRfqPartAuditViewList,
    getApplierSummaryAuditList
} from '@/controller/rfq'
import {
    RFQ_STATUS,
    USER_TYPE,
    QUOTATION_STATUS,
    getQUOTATION_STATUS_VALUE,
} from '@/utils/const'
import moment from 'moment'
import partmodel from './model/partmodel'
// require('@/mock/mockQuotation');
export default {
    props: {
        //供应商列表数据
        basicFormData: Object,
        supplierList: Array,
        viewFlag: Boolean,
        partList: Array,

    },
    data() {
        return {
            currTab: 'summary',
            RFQ_STATUS: RFQ_STATUS,
            QUOTATION_STATUS: QUOTATION_STATUS,
            QUOTATION_STATUS_VALUE: getQUOTATION_STATUS_VALUE,
            priceList: [],
            summaryList: [],
            selectSummaryData: [],
            selectPartData: [],
            flowableType: '', //TODO:
            USER_TYPE: USER_TYPE,
            currentPartCode: '',
            currentPartName: '',
            currentPartIndex: 0,
            currentPartCount: 0,
            roundNo: '1',
            flowParam: {
                flowTaskId: '',
                paramKey: '',
                paramVal: ''
            },
            dataRule: {
                // name: [{
                //     required: true,
                //     message: '组织名称不能为空',
                //     trigger: 'blur'
                // }],
                // code: [{
                //     required: true,
                //     message: '组织代码不能为空',
                //     trigger: 'blur'
                // }],
                // tenantName: [{
                //     required: true,
                //     message: '请先在页面顶部导航栏选择租户',
                //     trigger: 'blur'
                // }]
            },
            pm: new partmodel()
        }
    },
    mounted() {},
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD前")
        },
        dateFormatValue: function (value) {
            if (!value) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        // 查所有供应商表
        async getPriceList(id) {
            this.priceList = []
            await getRfqPartAuditViewList({
                rfqId: id,
                roundNo: this.roundNo
            }).then((data) => {
                if (data && data.code === "00") {
                    this.priceList = data.body
                    this.currentPartIndex = 1
                    this.currentPartCount = this.priceList.length
                } else {
                    this.priceList = [];
                    this.currentPartIndex = 0
                    this.currentPartCount = this.priceList.length
                }
            });
        },
        getApplierSummaryAuditList(id) {
            getApplierSummaryAuditList({
                rfqId: id,
                roundNo: this.roundNo
            }).then((data) => {
                if (data && data.code === "00") {
                    this.summaryList = data.body;
                } else {
                    this.priceList = [];
                }
            });
        },
        async handleCheckTabClick() {
            this.currentPartCode = this.partList[0].appartmentCode
            this.currentPartName = this.partList[0].appartmentName
            this.getApplierSummaryAuditList(this.basicFormData.id)
            await this.getPriceList(this.basicFormData.id)

            const pm = new partmodel()
            // pm.supplierList = this.supplierList
            // pm.partList = this.partList
            pm.parts = this.priceList
            pm.initData()
            this.pm = pm
            console.log(pm)
        },
        selectionSummaryChange(val) {
            // 更新供应商下所有零件 chooseFlag 注意轮次
            this.selectSummaryData = val
            // this.selectPartData = []
        },
        selectionPartChange(val) {
            // 更新零件 chooseFlag 注意轮次
            this.selectPartData = val
            // this.selectSummaryData = []
        },
        getPartData() {
            return this.priceList.filter(part => (part.rfqPartId && part.rfqSupplierId && part.roundNo)).map(part => {
                part.chooseFlag = 0
                const index = this.selectPartData.findIndex(select => select.id === part.id)
                const indexSupplier = this.selectSummaryData.findIndex(select => select.rfqSupplierId === part.rfqSupplierId)
                if (index >= 0 || indexSupplier >= 0) {
                    part.chooseFlag = 1
                }
                return {
                    rfqPartId: part.rfqPartId,
                    rfqSupplierId: part.rfqSupplierId,
                    roundNo: part.roundNo,
                    chooseFlag: part.chooseFlag
                }
            })
        },
        getSupplierData() {
            return this.summaryList.filter(supplier => (supplier.rfqSupplierId)).map(supplier => {
                supplier.chooseFlag = 0
                const indexSupplier = this.selectSummaryData.findIndex(select => select.rfqSupplierId === supplier.rfqSupplierId)
                if (indexSupplier >= 0) {
                    supplier.chooseFlag = 1
                }
                return {
                    id: supplier.rfqSupplierId,
                    chooseFlag: supplier.chooseFlag
                }
            })
        },
        async changeRoundNo(val) {
            this.getApplierSummaryAuditList(this.basicFormData.id)
            await this.getPriceList(this.basicFormData.id)
        }
    }
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}
</style>
